// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_1-3";
export var dialog = "_1-0";
export var divClassnameSwatch = "_1-8";
export var flexSwatch = "_1-4";
export var header = "_1-1";
export var styleAttributeSwatch = "_1-7";
export var swatch = "_1-2";
export var textHeaderSwatch = "_1-5";
export var webSwatch = "_1-6";